import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'

import { ErrorBoundary } from '@leverege/ui-elements'

import { ProjectActions, NetworkActions } from '../../actions'
import { Loading } from '../../views' // eslint-disable-line 
import RouteMatcher from '../../RouteMatcher'

import SystemsScreen from '../system/SystemsScreen'
import MessageRoutesScreen from '../messageRoute/MessageRoutesScreen'
import MessageRouteScreen from '../messageRoute/MessageRouteScreen'
import TimersScreen from '../timer/TimersScreen'
import ScriptsScreen from '../script/ScriptsScreen'
import ScriptHomeScreen from '../script/ScriptHomeScreen'
import TemplatesScreen from '../templates/TemplatesScreen'
import TemplateHomeScreen from '../templates/TemplateHomeScreen'
import NetworksScreen from '../network/NetworksScreen'
import SettingsScreen from './SettingsScreen'
import SystemHomeScreen from '../system/SystemHomeScreen'
import AuthzScreen from '../role/AuthzScreen'
import BlueprintHomeScreen from '../blueprint/BlueprintHomeScreen'
import BlueprintsScreen from '../blueprint/BlueprintsScreen'
import ImportRawBlueprintsScreen from '../blueprint/ImportRawBlueprintsScreen'
import ScenarioScreen from '../scenario/ScenarioScreen'
import ScenariosScreen from '../scenario/ScenariosScreen'
import ProjectAccountsScreen from '../user/ProjectAccountsScreen'
import BreadcrumbView from '../main/BreadcrumbView'
import ProjectUsersScreen from './ProjectUsersScreen'
import ProjectSidebar from './ProjectSidebar'
import ProjectError from './ProjectError'
import DeviceHomeScreen from '../device/DeviceHomeScreen'
import OidcScreen from '../oidc/OidcScreen'
import ApiAccessScreen from '../apiAccess/ApiAccessScreen'
import GeotilesScreen from '../geotile/GeotilesScreen'
import GeotileHomeScreen from '../geotile/GeotileHomeScreen'
import EnumHomeScreen from '../enum/EnumHomeScreen'
import MaintenanceEventHomeScreen from '../maintenanceEvent/MaintenanceEventHomeScreen'
import ProjectRulesScreen from './ProjectRulesScreen'
import ProjectRuleScreen from './ProjectRuleScreen'
import ClientIdScreen from '../clientId/ClientIdScreen'

class ProjectScreen extends React.Component {

  static routes = [
    <Route key="/project/:projectId/blueprint" path="/project/:projectId/blueprint" exact component={BlueprintsScreen} />,
    <Route key="/project/:projectId/importBlueprint" path="/project/:projectId/importBlueprint" exact component={ImportRawBlueprintsScreen} />,
    <Route key="/project/:projectId/blueprint/:blueprintId" path="/project/:projectId/blueprint/:blueprintId" exact={false} component={BlueprintHomeScreen} />,
    <Route key="/project/:projectId/scenario" path="/project/:projectId/scenario" exact component={ScenariosScreen} />,
    <Route key="/project/:projectId/scenario/:scenarioId" path="/project/:projectId/scenario/:scenarioId" exact={false} component={ScenarioScreen} />,
    <Route key="/project/:projectId/system" path="/project/:projectId/system" exact component={SystemsScreen} />,
    <Route key="/project/:projectId/messageRoute" path="/project/:projectId/messageRoute" exact component={MessageRoutesScreen} />,
    <Route key="/project/:projectId/messageRoute/:messageRouteId" path="/project/:projectId/messageRoute/:messageRouteId" exact component={MessageRouteScreen} />,
    <Route key="/project/:projectId/settings" path="/project/:projectId/settings" exact component={SettingsScreen} />,
    <Route key="/project/:projectId/apiAccess" path="/project/:projectId/apiAccess" exact={false} component={ApiAccessScreen} />,
    <Route key="/project/:projectId/clientId" path="/project/:projectId/clientId" exact={false} component={ClientIdScreen} />,
    <Route key="/project/:projectId/system/:systemId/device/:deviceId" path="/project/:projectId/system/:systemId/device/:deviceId" exact={undefined} component={DeviceHomeScreen} />,
    <Route key="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId" path="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId" exact={undefined} component={DeviceHomeScreen} />,
    <Route key="/project/:projectId/system/:systemId" path="/project/:projectId/system/:systemId" exact={false} component={SystemHomeScreen} />,
    <Route key="/project/:projectId/network" path="/project/:projectId/network" exact={undefined} component={NetworksScreen} />,
    <Route key="/project/:projectId/account" path="/project/:projectId/account" exact={undefined} component={ProjectAccountsScreen} />,
    <Route key="/project/:projectId/timer" path="/project/:projectId/timer" exact component={TimersScreen} />,
    <Route key="/project/:projectId/script" path="/project/:projectId/script" exact component={ScriptsScreen} />,
    <Route key="/project/:projectId/script/:scriptId" path="/project/:projectId/script/:scriptId" exact={false} component={ScriptHomeScreen} />,
    <Route key="/project/:projectId/template" path="/project/:projectId/template" exact component={TemplatesScreen} />,
    <Route key="/project/:projectId/template" path="/project/:projectId/template/:templateId" exact={false} component={TemplateHomeScreen} />,
    <Route key="/project/:projectId/authz" path="/project/:projectId/authz" exact={false} component={AuthzScreen} />,
    <Route key="/project/:projectId/oidc" path="/project/:projectId/oidc" exact={false} component={OidcScreen} />,
    <Route key="/project/:projectId/geotile" path="/project/:projectId/geotile" exact component={GeotilesScreen} />,
    <Route key="/project/:projectId/geotile/:geotileId" path="/project/:projectId/geotile/:geotileId" exact={false} component={GeotileHomeScreen} />,
    <Route key="/project/:projectId/enum"
      path={[
        '/project/:projectId/enum',
        '/project/:projectId/enum/:enumType',
        '/project/:projectId/resourceEnum',
        '/project/:projectId/resourceEnum/:enumType' ]}
      exact
      component={EnumHomeScreen} />,
    <Route key="/project/:projectId/rule"
      path="/project/:projectId/rule"
      exact
      component={ProjectRulesScreen} />,
    <Route key="/project/:projectId/rule/:ruleId"
      path="/project/:projectId/rule/:ruleId"
      exact
      component={ProjectRuleScreen} />,
    <Route
      key="/project/:projectId/maintenanceEvent"
      path="/project/:projectId/maintenanceEvent"
      exact
      component={MaintenanceEventHomeScreen} />,
    <Route 
      key="/project/:projectId/authz" 
      path="/project/:projectId/users" 
      exact={false} 
      component={ProjectUsersScreen} />,
    <Route key="index" path="/" exact={false} component={ProjectError} />
  ]
  
  static propTypes = {
    project : PropTypes.object
  }

  constructor( props ) {
    super( props )
    this.routeMatcher = new RouteMatcher( ProjectScreen.routes, { missComponent : ProjectError } )
  }

  componentDidMount() {
    const { dispatch, match } = this.props 

    dispatch( ProjectActions.getProject( match.params.projectId ) )
    dispatch( NetworkActions.requestNetworks( match.params.projectId ) )
  }

  render() {
    const { history, project, match, location, auth } = this.props

    if ( project == null ) {
      return <Loading show message="Loading Project..." />
    } if ( project.error ) {
      return <ProjectError message={project.message} statusCode={project.status} />
    } if ( project.id !== match.params.projectId ) {
      return <Loading show message="Loading Project..." />
    }

    const grp = (
      <BreadcrumbView>
        <ErrorBoundary>
          <Switch>{ProjectScreen.routes}</Switch>
        </ErrorBoundary>
      </BreadcrumbView>
    )

    return (
      <ErrorBoundary>
        <ProjectSidebar 
          location={location}
          history={history}
          params={match.params}
          project={project}
          content={grp} />
      </ErrorBoundary>
    )
  }
}

export default connect(
  state => ( {
    project : state.project,
  } )
)( ProjectScreen )
